import {isNotNil} from 'ramda-adjunct';

/**
 * Builds a display string for an auction pickup-point name (address + city).
 */
export function buildLocationName(
  address: string | null | undefined,
  city: string | null | undefined
): string {
  if (isNotNil(address) && isNotNil(city)) {
    return `${address}, ${city}`;
  }

  if (isNotNil(address)) {
    return address;
  }

  return city ?? '';
}

/**
 * Builds a display string for an auction pickup-point detail (zip + country).
 */
export function buildLocationDetail(
  zip: string | null | undefined,
  country: string | null | undefined
): string {
  if (isNotNil(zip) && isNotNil(country)) {
    return `${zip}, ${country}`;
  }

  if (isNotNil(zip)) {
    return zip;
  }

  return country ?? '';
}
